import Select from "react-select";
import { IoInformationCircleOutline } from "react-icons/io5";
import { HiOutlineExternalLink } from "react-icons/hi";
import "./dropdown.css";

function Dropdown({ config, setStateField, activeOptionIndex, hint = null }) {
    const handleChange = (option) => {
        setStateField(config.fieldName, option.value);
    };
    return (
        <div className="dropdown-container">
            <div className={"label-container"}>
                <p
                    onClick={config.docsLink ? () => window.open(config.docsLink) : null}
                    className={config.docsLink ? "label has-hyperlink" : "label"}
                >
                    {config.fieldName}
                    {config.docsLink &&
                        <HiOutlineExternalLink className={"external-link-icon"} />
                    }
                </p>
                {hint &&
                    <p className="hint">Hint: {hint}</p>
                }
                <IoInformationCircleOutline
                    data-tooltip-id={"info-tooltip"}
                    data-tooltip-place={"right"}
                    data-tooltip-content={config.tooltip}
                />
            </div>
            <Select
                value={config.options[activeOptionIndex]}
                onChange={handleChange}
                options={config.options}
                classNamePrefix={"react-select"}
                theme={(theme) => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        neutral0: 'var(--background-color)',
                        neutral20: 'var(--border-color)',
                        neutral80: 'var(--color)',
                        neutral40: 'var(--color)',
                        primary25: 'var(--secondary-background-color)',
                        primary: 'var(--primary-color)',
                    },
                })}
            />
        </div>
    );
}

export default Dropdown;
